const RESOURCE_NAME = "entities/activityWords";

export default {};
